'use strict'

function ValidationError (errors) {
  this.name = 'ValidationError'
  this.errors = errors
}

ValidationError.prototype = Error.prototype

module.exports = ValidationError



//////////////////
// WEBPACK FOOTER
// ./~/har-validator/lib/error.js
// module id = 219
// module chunks = 0 1